// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderPlan {
    static getAttributeTypeMap() {
        return PharmacyCardFinderPlan.attributeTypeMap;
    }
}
PharmacyCardFinderPlan.discriminator = undefined;
PharmacyCardFinderPlan.additionalProperties = false;
PharmacyCardFinderPlan.attributeTypeMap = [
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "cardHolderId",
        "baseName": "cardHolderId",
        "type": "string"
    },
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "string"
    },
    {
        "name": "familyUnitNumber",
        "baseName": "familyUnitNumber",
        "type": "string"
    },
    {
        "name": "groupId",
        "baseName": "groupId",
        "type": "string"
    },
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PharmacyCardFinderPatientResponse"
    },
    {
        "name": "pbmName",
        "baseName": "pbmName",
        "type": "string"
    },
    {
        "name": "pbmPhone",
        "baseName": "pbmPhone",
        "type": "string"
    },
    {
        "name": "pbmResponseMessage",
        "baseName": "pbmResponseMessage",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderPlan.js.map